import React from 'react';
import PropTypes from 'prop-types';
import PDFJS from 'pdfjs-dist'; // Main lib

export default class MiniImage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            visible: false,
        };
    }

    /**
     *  render page to the canvas todo remove PDFJS from this file
     */
    renderPage = () => {
        let { page, blob, scale } = this.props;
        if (!this.frame) return;
        PDFJS.getDocument(blob).then(pdf => {
            pdf.getPage(page).then(page => {
                let viewport = page.getViewport(scale);
                let canvas = this.frame;
                let context = canvas.getContext('2d');
                canvas.height = viewport.height;
                canvas.width = viewport.width;
                let renderContext = {
                    canvasContext: context,
                    viewport: viewport,
                };
                page.render(renderContext);
            });
        });
    };

    /**
     *  check for visible and render only if the frame visible
     * @param newProps
     */
    componentWillReceiveProps(newProps) {
        if (newProps.visible && !this.state.visible) {
            this.setState({ visible: true });
            this.renderPage();
        }
    }

    render() {
        return (
            <div className="thumbs-panel-list-item-image-wrap">
                {this.props.children}
                {this.props.isThereNotesOnPage && (
                    <div className="thumbs-panel-list-item-notes">{this.props.notesIcon}</div>
                )}
                <div className="thumbs-panel-list-item-image">{this.props.page}</div>
                <canvas
                    ref={el => (this.frame = el)}
                    className="thumbs-panel-list-item-image-canvas"
                />
            </div>
        );
    }
}

MiniImage.propTypes = {
    page: PropTypes.number,
    blob: PropTypes.string,
    visible: PropTypes.bool,
    scale: PropTypes.number,
    selected: PropTypes.bool,
    isThereNotesOnPage: PropTypes.bool,
    notesIcon: PropTypes.any,
};

MiniImage.defaultProps = {
    visible: false,
    scale: 0.24,
    selected: false,
    isThereNotesOnPage: false,
    notesIcon: (
        <div
            style={{
                backgroundColor: 'yellow',
                width: '1.25rem',
                height: '1.65rem',
                borderRadius: '3px',
                border: '1px solid lightgray',
            }}
        />
    ),
};



// WEBPACK FOOTER //
// ./src/containers/PrivateArea/DocumentViewer/src/MiniImage.js